import AntTooltip, { type TooltipProps as AntTooltipProps } from "antd/lib/tooltip";
import { FC } from "react";

export type TooltipProps = AntTooltipProps;

export const Tooltip: FC<TooltipProps> = props => <AntTooltip {...props} />;
